literalSegments